import Font from '@maxpreps/shared/styles/font';
import styled from 'styled-components';
import { MAXPREPS_HOME } from '../../constants/urls';
import THEME, { COLOR } from '../../styles/colors';
import Icon, { IconType } from '../../ui/Icon/Icon';
import { iconMPLogo } from '../../ui/Icon/mp/MaxPrepsLogo';
import Text from '../../ui/Text/StyledText';
import Anchor from '../Anchor/Anchor';
import HamburgerSearch from './HamburgerSearch';
import HamburgerSocialLinks from './HamburgerSocialLinks';
import HamburgerSubMenu from './HamburgerSubMenu';

const StyledHamburgerList = styled.ul`
  & > li:not(:last-child) {
    border-bottom: 1px solid ${THEME.general.border};
  }
  & > li:last-child {
    margin-bottom: 50px;
  }
`;

interface IHamburgerListItemProps {
  linkData: any;
}

const HamburgerListItem: React.FC<IHamburgerListItemProps> = ({ linkData }) => {
  const { href, text, subItems } = linkData;

  // (Ryan - 12/9/2020) only reason i plugged 'href.replace' is to fix a SSR/CSR render bug
  // The /video/ and /photography/ links has ended with a slash on the server but not on the client.
  // I just removed the trailing slash ('/') to make it consistent
  // I'm trying to find a bigger bug is why i'm hack fixing this but we should get a ticket in to resolve sometime down the road.
  const component = subItems ? (
    <HamburgerSubMenu {...linkData} />
  ) : href ? (
    <Anchor
      href={href.replace(new RegExp(/\/$/), '')}
      className={Font.f16_bold_tall}
      $color={COLOR.black}
      $hoverColor={THEME.brand.maxpreps}
      $display="block"
      $width="100%"
      $padding="10px 0"
    >
      {text}
    </Anchor>
  ) : (
    <Text
      className={Font.f16_bold_tall}
      $hoverColor={THEME.brand.maxpreps}
      $padding="10px 0"
    >
      {text}
    </Text>
  );
  return <li key={text}>{component}</li>;
};

interface IHamburgerMenuProps {
  hamburgerNavData: any[];
  isSearchFocused?: boolean;
}

const HamburgerMenu: React.FC<IHamburgerMenuProps> = ({
  hamburgerNavData,
  isSearchFocused
}) => (
  <>
    <Anchor
      $textAlign="center"
      $display="block"
      $paddingBottom="20px"
      $width="100px"
      $margin="auto"
      href={MAXPREPS_HOME}
    >
      <Icon
        iconType={IconType.MaxPreps}
        icon={iconMPLogo}
        width={90}
        color={THEME.brand.maxpreps}
      />
    </Anchor>
    <HamburgerSearch isSearchFocused={isSearchFocused ?? false} />
    <StyledHamburgerList>
      {hamburgerNavData.map(linkData => (
        <HamburgerListItem linkData={linkData} key={linkData.text} />
      ))}
    </StyledHamburgerList>
    <HamburgerSocialLinks />
  </>
);

export default HamburgerMenu;
